import { useEffect, useState } from 'react';
import { HttpTransportType, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import store from '../../store';
import { useDispatch } from 'react-redux';
import { addSignalRConnection, isReconnected, removeSignalRConnection } from '../../actions/SignalRhubs';

const useSignalR = (hubUrl, type, isReconnectedCalled = false) => {
    const [connection, setConnection] = useState(null);
    const dispatch = useDispatch();

    let token = store.getState()?.Login?.token;

    // Initial connection setup
    useEffect(() => {
        if (!isReconnectedCalled && hubUrl) {
            const newConnection = new HubConnectionBuilder()
                .withUrl(hubUrl, {
                    accessTokenFactory: () => token
                })
                .configureLogging(LogLevel.Information)
                .withAutomaticReconnect()
                .build();

            dispatch(addSignalRConnection(type, newConnection));
            setConnection(newConnection);
        }
    }, [hubUrl]);

    // Start connection
    useEffect(() => {
        if (!isReconnectedCalled && connection) {
            connection.start()
                .then(() => console.log(`${type} SignalR Connected`))
                .catch(err => console.error(`${type} SignalR Connection Error: `, err));
        }
    }, [connection]);

    // Reconnect with new token
    const reconnect = async (newToken, newHubUrl = hubUrl, hubType = type) => {
        console.log(`[${hubType}] Attempting reconnect with new token...`);

        if (connection && connection.state === 'Connected') {
            try {
                await connection.stop();
                console.log(`[${hubType}] Connection stopped.`);
            } catch (err) {
                console.error(`[${hubType}] Error stopping connection:`, err);
            }
        }

        const newConnection = new HubConnectionBuilder()
            .withUrl(newHubUrl, {
                accessTokenFactory: () => newToken
            })
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        try {
            await newConnection.start();
            console.log(`[${hubType}] Reconnected successfully`);
        } catch (err) {
            console.error(`[${hubType}] Error starting new connection:`, err);
        }

        dispatch(addSignalRConnection(hubType, newConnection));
        dispatch(isReconnected(hubType, true));
        setConnection(newConnection);
    };


    return { connection, reconnect };
};

export default useSignalR;
